import type { ReactNode } from "react";
import React from "react";

import { ErrorModeBlankView } from "@/components";

export class ErrorBoundary extends React.Component<{ children: ReactNode }, {
    error?: Error,
    hasError: boolean
}> {
    constructor(props: { children: ReactNode }) {
        super(props);

        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Partial<Error> & { code?: string }) {
        return {
            error,
            hasError: true,
        };
    }

    render() {
        if (this.state.hasError) return <ErrorModeBlankView error={this.state.error} />; // eslint-disable-line

        return this.props.children; // eslint-disable-line
    }
}
